module.exports = __webpack_public_path__ + "img/Gamer Garage.8d0b2f8e.png";